/**
 * Decides whether a user may see a menu item.
 *
 * Items are gated one of two ways: by role (`access: ["Admin", ...]`) or by a
 * per-user flag on the token (`requires: "posAccess"`). A flag is deliberate —
 * it is never implied by a role — so it is checked on its own.
 */
export const canAccessMenuItem = (item, user) => {
  if (!user || !item) return false;
  if (user.isSuperadmin) return true;
  if (item.requires) return user[item.requires] === true;
  return (item.access || []).includes(user.role);
};
